import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { getField } from 'apps/auth/components/form-multi/utils';
import { ACCOUNT_TO } from 'apps/auth/constants/fieldsName';
import { GA_SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_PAY_STATUS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

import PreCheckButtons from './PreCheckButtons';
import PreCheckDetails from './PreCheckDetails';
import PreCheckMainView from './PreCheckMainView';
import PreCheckRecipient from './PreCheckRecipient';
import PreCheckTerms from './PreCheckTerms';

const PreCheck = (props) => {
    const { precheck = {}, pocket = {}, payment_form = {}, exchangeRatioText, toCountry = {}, code } = useExtra();
    const messages = usePageMessages();
    const { formName = GA_SEND_FORM_NAME } = props;
    const { fields = {} } = useForm(formName);

    const payAgree = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef?.current?.close();
        const newFields = {};
        /* eslint-disable-next-line no-undef */
        newFields.id = getField('id', precheck.id);
        newFields.acceptedPayment = getField('acceptedPayment', true);
        apiFetchData('/auth/send/pay.action', newFields).then((json) => {
            if (json.redirectTo) {
                window.location.href = json.redirectTo;
            } else if (json.status) {
                window.location.href = `${AUTH_GA_PAY_STATUS}?id=${json.status.id}&pocketId=${pocket.id}`;
            }
        });
    };

    const closeHandler = () => {
        props.popupRef?.current?.open(<PreCheck {...props} />);
    };

    return (
        <ComplexPopup popupRef={props.popupRef} withoutButton textCenter withoutCloseButton hasBottomPanel hasPseudoTable>
            <Row indent="adaptive-32-48">
                <PreCheckMainView preCheck={precheck} messages={messages} />
            </Row>
            <Row indent="adaptive-32-48">
                <PreCheckDetails
                    recipientComponent={
                        <PreCheckRecipient
                            messages={messages}
                            preCheck={precheck}
                            paymentForm={payment_form}
                            closeHandlerForPopup={closeHandler}
                            code={code}
                            {...props}
                        />
                    }
                    exchangeRatioText={exchangeRatioText}
                    toAccountValue={fields[ACCOUNT_TO]?.value}
                    preCheck={precheck}
                    toCountry={toCountry}
                    paymentForm={payment_form}
                    messages={messages}
                    closeHandlerForPopup={closeHandler}
                    {...props}
                />
            </Row>
            <PreCheckTerms preCheck={precheck} precheckTerms={messages.precheckTerms} />
            <PreCheckButtons payAgree={payAgree} paymentForm={payment_form} caption={messages.precheckAgreeButton} />
        </ComplexPopup>
    );
};
export default connect(null, { toggleSpinner })(PreCheck);
